import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csColorText } from '@cloudsuite/mosaic-shared/styles/colors.style.js'

export const style: CSSResult = css`
  :host {
    display: block;
    --cs-font-body-s-color: ${csColorText.muted};
  }

  .csc-discount-bundle {
    --cse-paper-row-gap: ${csSpacing.spacing06};
  }

  .csc-discount-bundle__connector {
    color: ${csColorText.headings};
  }

  .csc-discount-bundle__products--flexible {
    flex: 1 1 auto;
    min-width: 0;
  }

  .csc-discount-bundle__price-cta {
    flex-shrink: 0;
  }

  .csc-discount-bundle__mobile-product-picture {
    --cse-selectable-padding-y: ${csSpacing.spacing05};
    --cse-selectable-padding-x: ${csSpacing.spacing05};
  }

  .csc-discount-bundle__mobile-product-picture-image {
    flex: 0 0 auto;
    width: 64px;
    height: 64px;
    --csc-product-image-height-mobile: 64px;
    --csc-product-image-height-desktop: 64px;
  }
`
